import { getFlowConfig } from '../flow-initial/getFlowConfig';
export const useOAuthSignup = () => {
  const oAuthsEnabledByFlowConfig = getFlowConfig().oAuthsEnabled;
  const atLeastOneOAuthEnabled = Object.values(oAuthsEnabledByFlowConfig).some(value => value);
  return {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  };
};